










import Vue from 'vue';

export default Vue.extend({
  name: 'icon-cross',
  props: {
    color: {
      type: String,
      required: false,
      default: '#FFFFFF',
    },
  },
});
